(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import PhysicalDataModule from './components/PhysicalDataModule';
var _default = {
  id: 'plugin-physical-data',
  path: '/physical-data',
  name: t('ehr', 'Physical Data'),
  MenuModule: {
    name: t('ehr', 'Physical Data'),
    icon: 'FolderSharedOutlined',
    priority: 100
  },
  WidgetModule: {
    name: t('ehr', 'Physical Data'),
    icon: 'FolderSharedOutlined',
    priority: 100
  },
  DataModule: {
    Component: PhysicalDataModule
  }
};
export default _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(_default, "default", "/home/runner/html/nextcloud/apps/ehr/js/plugins/physicalData/src/index.js");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();